export const NAV_LINKS = [
  { to: "/leaderboard", label: "Leaderboard", testId: "nav-link-leaderboard" },
  { to: "/champions", label: "Champions", testId: "nav-link-champions" },
  { to: "/teams", label: "Teams", testId: "nav-link-teams" },
  { to: "/schedule", label: "Schedule", testId: "nav-link-schedule" },
  { to: "/gallery", label: "Gallery", testId: "nav-link-gallery" },
  { to: "/draft", label: "Draft", testId: "nav-link-draft" },
  { to: "/committee", label: "Committee", testId: "nav-link-committee" },
  { to: "/brandon", label: "Brandon", testId: "nav-link-brandon" },
  { to: "/rules", label: "Rules", testId: "nav-link-rules" },
];
